
.SecondaryLayoutWithActions {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    background: var(--soniq-t--global--background--gradient--primary-glow);
}


.SecondaryLayoutWithActions__centerPanel {
    flex-grow: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.SecondaryLayoutWithActions__header {
    height: 48px;
}

.SecondaryLayoutWithActions__content {
    container-type: inline-size;
    overflow-x: hidden;
    overflow-y: auto;
    flex-grow: 1;
    position: relative;
}

.SecondaryLayoutWithActions__contentHasPadding {
    padding: 1rem;
}

